import ChartWrapper from './ChartWrapper';

export default ChartWrapper;
